import spinner from '../utils/rbata.spinner';
import urlService from '../services/rbata.urlService';
import logger from '../utils/rbata.logger';

const techOverlay = {
    techTriggerSelector: '.js-tech-trigger',
    $techModal:          undefined,
    $body:               undefined,
    init() {
        this.$techModal = $('#techModal');
        this.$body      = $('body');
        this.bindEvents();
    },

    bindEvents() {
        this.$body.on('click', this.techTriggerSelector, this.clickTechHandler);
        this.$techModal.on('hidden.bs.modal', this.cleanupModal.bind(this));
    },

    clickTechHandler(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();
        const techCode = evt.currentTarget.dataset.techCode
        techOverlay.fetchTechnologyData(techCode);
    },

    fetchTechnologyData(techCode) {
        spinner.visibility(true);
        $.ajax({
            url:    `${urlService.getBaseUrl()}technologyoverlay/?technologyCode=${techCode}`,
            method: 'GET',
            cache:  true
        }).done((response) => {
            this.fillModalContent(response);
            this.$techModal.modal('show');
        }).fail((jqXHR) => {
            logger.error(`${jqXHR.status} error in techOverlay.fetchTechnologyData`);
        }).always(() => {
            spinner.visibility(false);
        });
    },

    fillModalContent(response) {
        this.$techModal
            .find('.modal-body')
            .html(response);
    },

    cleanupModal() {
        this.$techModal
            .find('.modal-body')
            .empty();
    }
}

$(() => {
    // Init every time. Some tiles are lazy loaded (CDS, yMarketing)
    techOverlay.init();
});

export default techOverlay;
